import React from 'react';
import { Container, Box } from '@mui/material';
import CustomAppBar from '../CustomAppBar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <>
      {/* AppBar no topo */}
      <CustomAppBar />
      {/* Container principal do conteúdo */}
      {children}
    </>
  );
};

export default MainLayout;
